import React from "react";
import { STATUS_META } from "@/lib/constants";

export default function StatusBadge({ status }) {
  const meta = STATUS_META[status] || { label: status, cls: "bg-slate-100 text-slate-700 border-slate-200" };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wider ${meta.cls}`}
    >
      {meta.label}
    </span>
  );
}
